import React, { useState, useEffect, useMemo } from "react";
import "./UserManagement.scss";
import AddUserModal from "./AddUserModal";
import ViewEditUserModal from "./ViewEditUserModal";
import DeactivateUserModal from "./DeactivateUserModal";
import { useDispatch, useSelector } from "react-redux";
import {
  vendorUserList,
  viewVendorUser,
} from "../../redux/actions/UserManagementAction";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import FullPageLoader from "../Loader/FullPageLoader";

const UserManagement = () => {
  // const [searchTerm, setSearchTerm] = useState('');
  const darkMode = localStorage.getItem("Theme") === "true" ? true : false;
  const dispatch = useDispatch();
  const [ToggleAddUser, setToggleAddUser] = useState(false);
  const [ToggleViewEditUser, setToggleViewEditUser] = useState("");
  const [ToggleDeactivateUser, setToggleDeactivateUser] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [viewVendorData, SetViewVendorData] = useState();
  const [vendorId, setVendorId] = useState("");
  const [active, setActive] = useState();
  const isLoading = useSelector((state) => state.vendorUserList.loading);
  console.log(vendorId);
  console.log(vendorList);
  const handleCloseAddUserModal = () => {
    setToggleAddUser(false);
  };

  const handleCloseViewEditModal = () => {
    setToggleViewEditUser("");
  };

  const handleCloseDeactivateModal = (vendorId, activestate) => {
    setToggleDeactivateUser(true);
    setVendorId(vendorId);
    setActive(activestate);
  };

  const handleCloseDeactModal = () => {
    setToggleDeactivateUser(false);
  };

  // const handleSaveAddUser = (data) => {
  //   console.log("handledata:::::::::::::",data)
  // }

  const viewSingleVendorUser = (vendorId) => {
    setToggleViewEditUser("View");
    const data = {
      vendor_id: vendorId,
    };
    const successFn = (response) => {
      console.log("hdjhsvdjshv", response.data);
      SetViewVendorData(response?.data);
    };
    const failureFn = (error) => {
      console.log(error);
    };
    dispatch(viewVendorUser({ data, successFn, failureFn }));
  };

  const listVendorUser = () => {
    const clientInfoID = localStorage.getItem("client_info_id");
    const data = {
      client_info_id: clientInfoID,
    };
    const successFn = (response) => {
      console.log("VendorList", response.data);
      setVendorList(response?.data);
    };
    const failureFn = (error) => {
      console.log(error);
    };
    dispatch(vendorUserList({ data, successFn, failureFn }));
  };

  useEffect(() => {
    if (!ToggleAddUser) {
      listVendorUser();
    }
  }, [ToggleAddUser]);

  useEffect(() => {
    if (!ToggleDeactivateUser) {
      listVendorUser();
    }
  }, [ToggleDeactivateUser]);

  const getMRTTheme = (darkMode) => ({
    baseBackgroundColor: darkMode ? "#2b2b2b" : "#f5f5f5",
    draggingBorderColor: darkMode ? "#444444" : "#cccccc",
    matchHighlightColor: darkMode ? "#ffeb3b" : "#ffeb3b",
    menuBackgroundColor: darkMode ? "#2c2c2c" : "#ffffff",
    pinnedRowBackgroundColor: darkMode ? "#3c3c3c" : "#e0e0e0",
    selectedRowBackgroundColor: darkMode ? "#424242" : "#d1eaff",
  });

  const columns = useMemo(
    () => [
      {
        accessorKey: "first_name",
        header: "Name",
      },
      {
        accessorKey: "email_id",
        header: "Email Id",
      },
      {
        accessorKey: "role",
        header: "Role",
      },
      {
        accessorKey: "last_login",
        header: "Most Recent Login",
      },
      {
        accessorKey: "mail_sent_time",
        header: "Email Sent time",
      },
      {
        accessorKey: "vendor_onboard_time",
        header: "User Registered",
      },
      {
        accessorKey: "state",
        header: "Status",
      },
    ],
    []
  );
  const table = useMaterialReactTable({
    columns,
    data: vendorList,
    enableColumnFilters: false,
    enableHiding: false,
    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "calc(100% - 7rem)", height: "calc(100% - 7rem)" } },
    enableRowActions: true,
    initialState: {
      columnPinning: {
        right: ["mrt-row-actions"],
      },
    },
    paginationDisplayMode: "pages",
    renderRowActions: ({ row }) => (
      <div className='actions'>
        <div title={row?.original?.state !== "Pending" ? "View User" : ""}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='1.25rem'
            height='1.25rem'
            viewBox='0 0 21 20'
            fill='none'
            className={
              row?.original?.state === "Pending" ||
              row?.original?.is_vendor_admin_user === 1
                ? "disabled"
                : "enabled"
            }
            onClick={
              row?.original?.state === "Pending" ||
              row?.original?.is_vendor_admin_user === 1
                ? null
                : () => {
                    viewSingleVendorUser(row?.original?.sub_vendor_id);
                    setVendorId(row?.original?.sub_vendor_id);
                  }
            }>
            <path
              d='M10.5 4.6875C11.9965 4.68853 13.4637 5.10285 14.7397 5.88477C16.0157 6.66669 17.0509 7.78582 17.7313 9.11875C17.8701 9.39175 17.9425 9.69371 17.9425 10C17.9425 10.3063 17.8701 10.6082 17.7313 10.8812C17.0494 12.2121 16.0135 13.329 14.7376 14.109C13.4618 14.8889 11.9954 15.3016 10.5 15.3016C9.00463 15.3016 7.53825 14.8889 6.26237 14.109C4.98649 13.329 3.95059 12.2121 3.26876 10.8812C3.12989 10.6082 3.05751 10.3063 3.05751 10C3.05751 9.69371 3.12989 9.39175 3.26876 9.11875C3.94909 7.78582 4.98435 6.66669 6.26034 5.88477C7.53633 5.10285 9.00349 4.68853 10.5 4.6875ZM4.38126 10.3125C4.95819 11.4386 5.83472 12.3837 6.91431 13.0436C7.99391 13.7036 9.23469 14.0528 10.5 14.0528C11.7653 14.0528 13.0061 13.7036 14.0857 13.0436C15.1653 12.3837 16.0418 11.4386 16.6188 10.3125C16.6736 10.2175 16.7025 10.1097 16.7025 10C16.7025 9.89029 16.6736 9.78251 16.6188 9.6875C16.0418 8.56136 15.1653 7.61629 14.0857 6.95636C13.0061 6.29642 11.7653 5.94723 10.5 5.94723C9.23469 5.94723 7.99391 6.29642 6.91431 6.95636C5.83472 7.61629 4.95819 8.56136 4.38126 9.6875C4.3264 9.78251 4.29752 9.89029 4.29752 10C4.29752 10.1097 4.3264 10.2175 4.38126 10.3125Z'
              fill='#102C97'
            />
            <path
              d='M10.5 7.1875C11.0563 7.1875 11.6 7.35245 12.0625 7.66149C12.5251 7.97053 12.8855 8.40979 13.0984 8.9237C13.3113 9.43762 13.367 10.0031 13.2585 10.5487C13.1499 11.0943 12.8821 11.5954 12.4887 11.9887C12.0954 12.3821 11.5943 12.6499 11.0487 12.7585C10.5031 12.867 9.93762 12.8113 9.4237 12.5984C8.90978 12.3855 8.47053 12.0251 8.16149 11.5625C7.85245 11.1 7.6875 10.5563 7.6875 10C7.68915 9.25459 7.986 8.54017 8.51308 8.01309C9.04017 7.486 9.75458 7.18915 10.5 7.1875ZM10.5 11.5625C10.809 11.5625 11.1111 11.4709 11.3681 11.2992C11.625 11.1275 11.8253 10.8835 11.9436 10.5979C12.0618 10.3124 12.0928 9.99827 12.0325 9.69517C11.9722 9.39208 11.8234 9.11367 11.6049 8.89515C11.3863 8.67663 11.1079 8.52781 10.8048 8.46752C10.5017 8.40723 10.1876 8.43818 9.90206 8.55644C9.61655 8.6747 9.37252 8.87497 9.20083 9.13192C9.02914 9.38887 8.9375 9.69097 8.9375 10C8.9375 10.4144 9.10212 10.8118 9.39514 11.1049C9.68817 11.3979 10.0856 11.5625 10.5 11.5625Z'
              fill='#102C97'
            />
          </svg>
        </div>

        {row?.original?.state !== "Deactivated" && (
          <div
            title={
              row?.original?.state !== "Pending" ? "De-activate User" : ""
            }>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='1rem'
              height='1rem'
              viewBox='0 0 16 16'
              fill='none'
              className={
                row?.original?.state === "Pending" ||
                row?.original?.is_vendor_admin_user === 1
                  ? "disabled"
                  : "enabled"
              }
              onClick={
                row?.original?.state === "Pending" ||
                row?.original?.is_vendor_admin_user === 1
                  ? null
                  : () =>
                      handleCloseDeactivateModal(
                        row?.original?.sub_vendor_id,
                        row?.original?.state
                      )
              }>
              <g clip-path='url(#clip0_14268_90514)'>
                <path
                  d='M8.00001 1.33398C4.31668 1.33398 1.33334 4.31732 1.33334 8.00065C1.33334 11.684 4.31668 14.6673 8.00001 14.6673C11.6833 14.6673 14.6667 11.684 14.6667 8.00065C14.6667 4.31732 11.6833 1.33398 8.00001 1.33398ZM2.66668 8.00065C2.66668 5.05398 5.05334 2.66732 8.00001 2.66732C9.23334 2.66732 10.3633 3.09065 11.2667 3.79065L3.79001 11.2673C3.09001 10.364 2.66668 9.23398 2.66668 8.00065ZM8.00001 13.334C6.76668 13.334 5.63668 12.9107 4.73334 12.2107L12.21 4.73398C12.91 5.63732 13.3333 6.76732 13.3333 8.00065C13.3333 10.9473 10.9467 13.334 8.00001 13.334Z'
                  fill='black'
                />
              </g>
              <defs>
                <clipPath id='clip0_14268_90514'>
                  <rect
                    width='16'
                    height='16'
                    fill='white'
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        )}

        {row?.original?.state === "Deactivated" && (
          <div
            title={row?.original?.state !== "Pending" ? "Activate User" : ""}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='1rem'
              height='1rem'
              viewBox='0 0 16 16'
              fill='none'
              className={
                row?.original?.state === "Pending" ? "disabled" : "enabled"
              }
              onClick={
                row?.original?.state === "Pending"
                  ? null
                  : () =>
                      handleCloseDeactivateModal(
                        row?.original?.sub_vendor_id,
                        row?.original?.state
                      )
              }>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M7.99998 2.16732C6.45288 2.16732 4.96915 2.7819 3.87519 3.87586C2.78123 4.96982 2.16665 6.45355 2.16665 8.00065C2.16665 9.54775 2.78123 11.0315 3.87519 12.1254C4.96915 13.2194 6.45288 13.834 7.99998 13.834C9.54708 13.834 11.0308 13.2194 12.1248 12.1254C13.2187 11.0315 13.8333 9.54775 13.8333 8.00065C13.8333 6.45355 13.2187 4.96982 12.1248 3.87586C11.0308 2.7819 9.54708 2.16732 7.99998 2.16732ZM0.833313 8.00065C0.833313 4.04265 4.04198 0.833984 7.99998 0.833984C11.958 0.833984 15.1666 4.04265 15.1666 8.00065C15.1666 11.9587 11.958 15.1673 7.99998 15.1673C4.04198 15.1673 0.833313 11.9587 0.833313 8.00065Z'
                fill='black'
              />
              <path
                d='M5.33329 7.33398C4.79996 7.33398 4.66663 7.77865 4.66663 8.00065C4.66663 8.53398 5.11129 8.66732 5.33329 8.66732H10.6666C10.8886 8.66732 11.3333 8.53398 11.3333 8.00065C11.3333 7.46732 10.8886 7.33398 10.6666 7.33398H5.33329Z'
                fill='black'
              />
            </svg>
          </div>
        )}

        <div title={row?.original?.state !== "Pending" ? "Edit User" : ""}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='1.25rem'
            height='1.25rem'
            viewBox='0 0 21 20'
            fill='none'
            className={
              row?.original?.state === "Pending" ||
              row?.original?.is_vendor_admin_user === 1
                ? "disabled"
                : "enabled"
            }
            onClick={
              row?.original?.state === "Pending" ||
              row?.original?.is_vendor_admin_user === 1
                ? null
                : () => {
                    viewSingleVendorUser(row?.original?.sub_vendor_id);
                    setToggleViewEditUser("Edit");
                    setVendorId(row?.original?.sub_vendor_id);
                  }
            }>
            <path
              d='M5.82812 17C5.34328 17 4.87829 16.8074 4.53545 16.4646C4.19261 16.1217 4 15.6567 4 15.1719V5.82813C4 5.34328 4.19261 4.87829 4.53545 4.53545C4.87829 4.19261 5.34328 4 5.82812 4H11.7187C11.8804 4 12.0354 4.0642 12.1496 4.17848C12.2639 4.29276 12.3281 4.44776 12.3281 4.60938C12.3281 4.77099 12.2639 4.92599 12.1496 5.04027C12.0354 5.15455 11.8804 5.21875 11.7187 5.21875H5.82812C5.7481 5.21875 5.66886 5.23451 5.59493 5.26514C5.52099 5.29576 5.45382 5.34065 5.39723 5.39723C5.34065 5.45382 5.29576 5.521 5.26514 5.59493C5.23451 5.66886 5.21875 5.7481 5.21875 5.82813V15.1719C5.21875 15.2519 5.23451 15.3311 5.26514 15.4051C5.29576 15.479 5.34065 15.5462 5.39723 15.6028C5.45382 15.6594 5.52099 15.7042 5.59493 15.7349C5.66886 15.7655 5.7481 15.7812 5.82812 15.7812H15.1719C15.3335 15.7812 15.4885 15.717 15.6028 15.6028C15.717 15.4885 15.7812 15.3335 15.7812 15.1719V9.48438C15.7812 9.32276 15.8455 9.16776 15.9597 9.05348C16.074 8.9392 16.229 8.875 16.3906 8.875C16.5522 8.875 16.7072 8.9392 16.8215 9.05348C16.9358 9.16776 17 9.32276 17 9.48438V15.1719C17 15.6567 16.8074 16.1217 16.4646 16.4646C16.1217 16.8074 15.6567 17 15.1719 17H5.82812ZM7.16266 13.4792L7.59193 10.9652C7.5914 10.9634 7.5914 10.9615 7.59193 10.9597L10.4628 8.08891L14.1982 4.35682C14.3112 4.24353 14.4454 4.15368 14.5932 4.09245C14.741 4.03121 14.8995 3.99979 15.0595 4C15.2206 3.99987 15.3803 4.0315 15.5292 4.09307C15.6781 4.15464 15.8135 4.24496 15.9275 4.35886L16.2843 4.71568L16.6432 5.07453C16.8716 5.30308 16.9999 5.61298 16.9999 5.93612C16.9999 6.25926 16.8716 6.56917 16.6432 6.79771L12.9084 10.5332L10.0389 13.404C10.0371 13.4045 10.0353 13.4045 10.0335 13.404L7.51948 13.8326C7.50204 13.8357 7.48437 13.8373 7.46667 13.8373C7.422 13.8372 7.3779 13.8274 7.33739 13.8086C7.29688 13.7898 7.26093 13.7624 7.23203 13.7284C7.20313 13.6943 7.18196 13.6544 7.16998 13.6114C7.15801 13.5684 7.15551 13.5233 7.16266 13.4792ZM11.326 8.95287L8.72604 11.5529L8.57776 12.4195L9.44443 12.2712L12.0444 9.67125L15.7812 5.93714L15.4224 5.57828L15.0635 5.21943L11.326 8.95287Z'
              fill='#102C97'
            />
          </svg>
        </div>
      </div>
    ),
    muiCircularProgressProps: {
      Component: <FullPageLoader />,
    },
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      "mrt-row-actions": {
        size: 100,
        grow: false,
      },
    },
    state: { isLoading },
    mrtTheme: getMRTTheme(darkMode),
  });

  return (
    <main className='UserManagement'>
      <section className='AddUser'>
        <button
          onClick={() => {
            setToggleAddUser(true);
          }}>
          Add User
        </button>
      </section>
      <section className='TableContainer'>
        <MaterialReactTable table={table} />
      </section>
      {ToggleAddUser && <AddUserModal handleClose={handleCloseAddUserModal} />}
      {ToggleViewEditUser && (
        <ViewEditUserModal
          type={ToggleViewEditUser}
          viewEditdata={viewVendorData}
          handleClose={handleCloseViewEditModal}
          handleEditSave={() => {
            setToggleViewEditUser(ToggleViewEditUser === "View" ? "Edit" : "");
          }}
          vendorId={vendorId}
        />
      )}
      {ToggleDeactivateUser && (
        <DeactivateUserModal
          vendorId={vendorId}
          active={active}
          handleClose={handleCloseDeactModal}
        />
      )}
    </main>
  );
};

export default UserManagement;
